import { IconButton } from "@mui/material";
import React, { Fragment, useRef } from "react";
import colors from "theme/themeConstants";
import { ReactComponent as PlusIcon } from "../icons/plusIcon.svg";
import { IMAGE_MIME_TYPES, validateMimeType, validateSize } from "utils/uploadFileValidation";
import { toast } from "react-hot-toast";
import { FileMimeTypeError } from "./FileMimeTypeError";
import { FileSizeError } from "./FileSizeError";
import { addFiles, MAX_FILES_COUNT } from "utils/uploadAddFile";

interface IProps {
  files: any;
  setFiles: (files: any) => void;
}

const UploadAddMoreFilesButton = (props: IProps) => {
  const {
    files,
    setFiles
  } = props;

  const imageInputRef = useRef<any>(null);

  const onAddClick = () => {
    if (imageInputRef && imageInputRef.current) {
      imageInputRef.current.click();
    }
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = event.target.files;
    if (newFiles === null) {
      return;
    }

    if (!validateSize(newFiles)) {
      toast.error(FileSizeError, {
        duration: 5000
      });
      return;
    }

    if (!validateMimeType(newFiles, IMAGE_MIME_TYPES)) {
      toast.error(FileMimeTypeError, {
        duration: 5000
      });
      return;
    }

    setFiles(await addFiles(files, newFiles));
  };

  return (
    <Fragment>
      <IconButton
        sx={{
          background: colors.redPink,
          color: colors.white,
          "&:hover": {
            background: colors.redPink
          },
          "&:disabled": {
            opacity: 0.6,
            background: colors.redPink
          }
        }}
        onClick={onAddClick}
        disabled={files.length >= MAX_FILES_COUNT}
      >
        <PlusIcon />
      </IconButton>
      <input
        style={{ display: "none" }}
        ref={imageInputRef}
        multiple
        type="file"
        accept="image/jpeg,image/png"
        onChange={handleFileChange}
      />
    </Fragment>
  );
};

export default UploadAddMoreFilesButton;
